import React, { useEffect } from 'react';
import { PageTitle } from '../../layout/core';
import './Profile.scss';
import { fetchSecurityInformation } from '../../store/identyti/actions/security';
import { useIdentity } from '../../store/identyti/identity-context';
import { ProfileSettingsAccountSecurity } from '../../components/profileSettings/ProfileSettingsAccountSecurity';
import {
	ProfileSettingsPersonalInformation
} from '../../components/profileSettings/ProfileSettingsPersonalInformation';
import { Spinner } from '../../components/Spinner';
import { ProfileHeader } from '../../components/profileSettings/ProfileHeader';
// import { ProfileSettingsPreferences } from '../../components/profileSettings/ProfileSettingsPreferences';

export const Profile = (): JSX.Element => {
	const { identityState: { isSecurityDataLoading }, dispatch } = useIdentity();

	useEffect(() => {
		const email = localStorage.getItem('userEmail');
		void fetchSecurityInformation(dispatch, email);
	}, []);

	const pageLoader = (
		<div className="card">
			<div className="card-body profile-page-height-loading">
				<Spinner pageLoader/>
			</div>
		</div>
	);

	return (
		<>
			<PageTitle breadcrumbs={[]}>Profile</PageTitle>

			<ProfileHeader/>

			{
				isSecurityDataLoading
					? pageLoader
					: (
						<>
							<ProfileSettingsPersonalInformation/>
							<ProfileSettingsAccountSecurity/>
							{/*<ProfileSettingsPreferences/>*/}
						</>
					)
			}

		</>
	);
};
